<template>
  <li
    v-if="canViewVerticalNavMenuLink(item)"
    class="nav-item"
    :class="{
      'active': isActive,
      'disabled': item.disabled
    }"
  >
    <b-link
      v-bind="linkProps"
      class="d-flex align-items-center"
      v-if="isMenuLinkVisibleForUser(item)"
    >
      <feather-icon :icon="item.icon || 'CircleIcon'" />
      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'

export default {
  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)
    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()
    const userData = JSON.parse(localStorage.getItem('userData'))

    const restrictedMenuTitles = ['Хэрэглэгч', 'Хандах эрх', 'Цэс', 'Байгууллага', 'Ангилал', 'Бүтээгдэхүүн', 'Ач холбогдол', 'Төлөв', 'Таг', 'Qpay']
    const restrictedMenuTitlesWhitelist = ['amaraa0207@gmail.com', 'yanjindulam@numur.mn', 'narangerel@numur.mn', 'uyanga@numur.mn', 'dulguun@numur.mn', 'munkhtuya@numur.mn']

    const loanEbarimtMenuTitles = ['И-баримт тест', 'Хяналтын тайлан']
    const loanEbarimtMenuTitlesWhitelist = ['uyanga@numur.mn', 'Enkhmaa@numur.mn', 'dulamsuren@numur.mn', 'sevjidnyam@numur.mn', 'narantuya@numur.mn', 'yanjindulam@numur.mn', 'munkhzaya@numur.mn']

    const isMenuLinkVisibleForUser = item => {
      if (restrictedMenuTitles.includes(item.title)) return restrictedMenuTitlesWhitelist.includes(userData.email)
      if (loanEbarimtMenuTitles.includes(item.title)) return loanEbarimtMenuTitlesWhitelist.includes(userData.email)
      return true
    }

    return {
      isActive,
      linkProps,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuLink,
      isMenuLinkVisibleForUser,

      // i18n
      t,
      userData
    }
  },

}
</script>
